<template>
    <div>
        <BModal id="modal-1" v-model="visible" size="lg" hideFooter hideHeader noCloseOnBackdrop noCloseOnEsc centered >
          <div v-if="errorType === 'ERR_NETWORK'">
            <BCard no-body class="mb-0 border-0 shadow-none mb-0">
              <BCardBody class="p-sm-5 m-lg-4">
                <div class="mt-2 text-center">
                    <div class="error-img text-center px-5">
                        <img src="@/assets/images/auth/offline-page.gif" class="img-fluid" alt="">
                    </div>
                    <h3 class="mt-2 fw-semibold">{{ $t('components.errors.networkTitle') }}</h3>
                    <p class="text-muted mb-4">{{ $t('components.errors.networkDescription') }}</p>
                    <BButton variant="primary" @click="reload()"><i class="fa-solid fa-arrows-rotate align-bottom"></i> {{ $t('actions.reload') }}</BButton>
                </div>
              </BCardBody>
            </BCard>
          </div>
          <div v-if="errorType === 'NOT_AUTHORIZED'">
            <BCard no-body class="mb-0 border-0 shadow-none mb-0">
              <BCardBody class="p-sm-5 m-lg-4">
                <div class="mt-2 text-center">
                    <div class="error-img text-center px-5">
                        <img src="@/assets/images/auth/permission.png" class="img-fluid" alt="">
                    </div>
                    <h3 class="mt-2 fw-semibold">{{ $t('components.errors.unauthorizedTitle') }}</h3>
                    <p class="text-muted mb-4">{{ $t('components.errors.supportDescription') }}</p>
                    <BButton variant="primary" @click="voltar()"><i class="fa-solid fa-arrows-rotate align-bottom"></i> {{ $t('actions.back') }}</BButton>
                    <BButton variant="secondary" @click="goToLogout()" class="ms-2"><i class="fa-solid fa-right-from-bracket align-bottom"></i> {{ $t('components.errors.logout') }}</BButton>
                </div>
              </BCardBody>
            </BCard>
          </div>
          <div v-if="errorType === 'NOT_FOUND'">
            <BCard no-body class="mb-0 border-0 shadow-none mb-0">
              <BCardBody class="p-sm-5 m-lg-4">
                <div class="mt-2 text-center">
                    <div class="error-img text-center px-5">
                        <img src="@/assets/images/auth/404.png" class="img-fluid" alt="">
                    </div>
                    <h3 class="mt-2 fw-semibold">{{ $t('components.errors.notFoundTitle') }}</h3>
                    <p class="text-muted mb-4">{{ $t('components.errors.notFoundDescription') }}</p>
                    <BButton variant="primary" @click="backToHome()"><i class="fas fa-home align-bottom"></i> {{ $t('components.errors.backHome') }}</BButton>
                </div>
              </BCardBody>
            </BCard>
          </div>


          <div v-if="errorType === 'PASSWORD_CHANGED'">
            <BCard no-body class="mb-0 border-0 shadow-none mb-0">
              <BCardBody class="p-sm-5 m-lg-4">
                <div class="mt-2 text-center">
                    <div class="error-img text-center px-5">
                        <img src="@/assets/images/auth/permission.png" class="img-fluid" alt="">
                    </div>
                    <h3 class="mt-2 fw-semibold">{{ $t('components.errors.passwordChangedTitle') }}</h3>
                    <p class="text-muted mb-4">{{ $t('components.errors.passwordChangedDescription') }}</p>
                    <BButton variant="secondary" @click="goToLogin()" class="ms-2"><i class="fa-solid fa-right-from-bracket align-bottom"></i> {{ $t('components.errors.goToLogin') }}</BButton>
                </div>
              </BCardBody>
            </BCard>
          </div>

          <div v-if="errorType === 'USER_CHANGED'">
            <BCard no-body class="mb-0 border-0 shadow-none mb-0">
              <BCardBody class="p-sm-5 m-lg-4">
                <div class="mt-2 text-center">
                    <div class="error-img text-center px-5">
                        <img src="@/assets/images/auth/permission.png" class="img-fluid" alt="">
                    </div>
                    <h3 class="mt-2 fw-semibold">{{ $t('components.errors.userChangedTitle') }}</h3>
                    <BButton variant="secondary" @click="goToLogin()" class="ms-2"><i class="fa-solid fa-right-from-bracket align-bottom"></i> {{ $t('components.errors.goToLogin') }}</BButton>
                </div>
              </BCardBody>
            </BCard>
          </div>

        </BModal>
    </div>
</template>

<script>
  import store from "@/state/store";
  import { closeModalError } from "@/state/helpers"
  export default {
    name: 'ModalError',
    components: {
    },
    computed: {
      visible() {
        return store.getters['notification/modalErrorVisible']
      },
      errorType() {
        return store.getters['notification/modalErrorType']
      }
    },
    methods: {
      reload() {
        window.location.reload();
      },
      voltar() {
        closeModalError()
        this.$router.back();
      },
      backToHome() {
        closeModalError()
        this.$router.push({name: 'home'})
      },
      goToLogout() {
        closeModalError()
        this.$router.push({name: 'logout'})
      },
      goToLogin() {
        closeModalError()
        this.$router.push({name: 'login'})
      }
    }
  };
</script>
